import * as a from '~/utils/UserStatus';
import { useCookie } from '#app';

export default function buildCustomerOffersRequestData(envProps) {
  const result = a.getCookie('MISCGCs');
  const envUserId = useCookie(`${envProps?.entryPoint === 'mcom' ? 'macys' : 'bloomingdales'}_online_uid`).value;

  if (!envUserId || !result) {
    return null;
  }

  return {
    uid: envUserId,
    headers: {
      accept: 'application/json',
      'X-Macys-SecurityToken': useCookie('secure_user_token').value || '',
      'X-Macys-UID': envUserId,
      SignedIn: useCookie('SignedIn').value ? 1 : 0,
    },
  };
}
